export const httpHashCompare = (previousPayload, nextPayload) =>
  previousPayload.payloadHash === nextPayload.payloadHash;

export const jsonCompare = (previousPayload, nextPayload) => {
  const previousStringValue = JSON.stringify({ payload: previousPayload });
  const nextStringValue = JSON.stringify({ payload: nextPayload });

  return previousStringValue === nextStringValue;
};
